
import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const PROrdersParts = {
	name: NAME,
	apiProvider,
	router,
};
